<div *ngIf="showEditButton" class="flex justify-between items-center mb-4">
  <h3 class="text-lg font-semibold">{{ 'BTB.DASHBOARD.COMMISSION_CONDITIONS' | translate }}</h3>
  <button
    mat-raised-button
    color="primary"
    (click)="onEditConditions()"
    class="bg-red-600 text-white hover:bg-red-700">
    <mat-icon class="mr-2">edit</mat-icon>
    {{ 'BTB.DASHBOARD.EDIT_CONDITIONS' | translate }}
  </button>
</div>

<div class="dashboard-box p-4">
  <div *ngIf="!showEditButton" class="text-lg font-semibold mb-2">{{ 'BTB.DASHBOARD.COMMISSION_CONDITIONS' | translate }}</div>
  <ul class="list-disc pl-6">
    <li *ngFor="let condicion of conditions">{{ condicion }}</li>
  </ul>
  <div *ngIf="conditions.length === 0" class="text-gray-400 text-center mt-2">
    {{ 'BTB.DASHBOARD.NO_CONDITIONS_DEFINED' | translate }}
  </div>
</div>
